import JSZip from 'jszip';
import { exportFileName } from './utils';

// Takes an array of { title, content } objects, each corresponding to a file to
// export, and returns the zipped content, deduplicating file names as needed
export const zipExportContent = (
  exportEntries: { title: string; content: string }[],
  extension: string,
) => {
  const zip = new JSZip();
  const filenameCounts: { [fileId: string]: number } = {}; // A count for each filename to deduplicate.
  exportEntries.forEach(({ title, content }) => {
    const fileId = exportFileName(title);
    const fileNumber = filenameCounts[fileId] || 0;
    const fileName = `${fileId}${fileNumber > 0 ? ` (${fileNumber})` : ''}`;
    filenameCounts[fileId] = fileNumber + 1;
    zip.file(`${fileName}.${extension}`, content);
  });
  return zip.generateAsync({ type: 'blob' });
};
